"use client";

import { useMemo } from "react";
import { observer } from "mobx-react";
import classNames from "classnames";

import Block from "../components/blocks/SchoolBlocks/_Block";
import headerStyles from "./styles/MainGridPage.module.scss";
import Breadcrumbs from "../components/misc/Breadcrumbs";
import ClickableLink from "../components/utilities/ClickableLink";
import { IBreadcrumb } from "./MainGridPage/MainGridPage";
import { useStores } from "../stores/useStores";
import { Button } from "@radix-ui/themes";
import { blockObjectFactory } from "../components/blocks/SchoolBlocks/blockObjectFactory";

const hide_header_block_types = ["news"];

export const ViewOrganizationHeader = observer(
  (props: {
    contentSources: ContentSource[] | undefined;
    breadcrumbs: IBreadcrumb[];
    isPreview: boolean;
  }) => {
    const { i18nStore } = useStores();
    const currentSource = props?.contentSources?.find(
      (source) =>
        source.language === i18nStore.currentOrgSupportedLocale ||
        source.language === i18nStore.orgDefaultLocale ||
        source.language === i18nStore.blockEditLanguage,
    );
    const fileSource: string =
      currentSource?.type?.split(".")[0] === "google_drive"
        ? "Drive"
        : "Microsoft";
    return (
      <div className={headerStyles.header}>
        <div className={headerStyles.classroomHeaderTopBlock}>
          <Breadcrumbs
            breadcrumbs={props.breadcrumbs}
            hasMicrosite={false}
            editable={!props.isPreview}
          />
          <div className={headerStyles.rightAlignedHeader}>
            {currentSource && (
              <div>
                <Button asChild>
                  <ClickableLink
                    href={currentSource?.source_url}
                    title={"View in " + fileSource}
                  >
                    {"View in " + fileSource}
                  </ClickableLink>
                </Button>
              </div>
            )}
          </div>
        </div>
      </div>
    );
  },
);

const ViewOrganization = observer(() => {
  const { interfaceStore, organizationStore } = useStores();
  const blockObj = organizationStore.currentOrganization.blockObj;
  const breadcrumbs = organizationStore.currentOrganization?.breadcrumbs;

  const sizeY = useMemo(() => {
    switch (interfaceStore.breakpoint) {
      case "break-point-xs":
        return 3;
      case "break-point-sm":
        return 5;
      default:
        return 7;
    }
  }, [interfaceStore.breakpoint]);

  const gridClassName = classNames({
    "sb-content-width": true,
    [headerStyles.grid]: true,
    [headerStyles.gridGridPage]: true,
  });

  return (
    <div className={headerStyles.container}>
      <div id={`sb-main-content`} className={gridClassName}>
        {hide_header_block_types.includes(blockObj.blockType) || (
          <ViewOrganizationHeader
            breadcrumbs={breadcrumbs}
            contentSources={
              organizationStore.currentOrganization.blockObj?.contentSources
            }
            isPreview={false}
          />
        )}
        <div style={{ paddingTop: "10px", textAlign: "center" }}>
          <Block
            blockObj={
              blockObjectFactory(blockObj.blockType, blockObj) as AnyBlockObj
            }
            loading={false}
            sizeX={4}
            sizeY={sizeY}
            outsideGrid={true}
            gridType={""}
            isFirst={false}
            locksAreEnabled={false}
            maxColumns={1}
            normalizedFirstCharacter={""}
            isBlockPreview={false}
            hasMicrosite={false}
          />
        </div>
      </div>
    </div>
  );
});

export default ViewOrganization;
